import React, { useState } from 'react'
import { Box, TextField, Button, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import Sidebar from './sidebar'
import CustomToolbar from './CustomToolbarPrint'
import ProjectFilter from './ProjectFilter'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '../firebase'
import { toNum, inDateRange, matchesDailyProject } from '../utils/reportUtils'

export default function HygieneReport() {
  const [date1, setdate1] = useState('')
  const [date2, setdate2] = useState('')
  const [projectFilter, setprojectFilter] = useState([])
  const [rows, setRows] = useState([])
  const [rows1, setRows1] = useState([])

  const handleProjects = (projects) => {
    setprojectFilter(projects)
    setRows([])
    setRows1([])
  }

  const summaryColumns = [
    { field: 'showers', headerName: 'Showers Provided', width: 200 },
  ]

  const columns = [
    { field: 'date', headerName: 'Date', width: 140 },
    { field: 'name', headerName: 'Submitted By', width: 180 },
    { field: 'showers', headerName: 'Showers Provided', width: 180 },
  ]

  const getData = async () => {
    if (projectFilter.length === 0) {
      setRows([])
      setRows1([])
      return
    }
    const q = collection(db, 'dailySumbissions')
    const querySnapshot = await getDocs(q)

    const details = []
    let total = 0

    querySnapshot.forEach((document) => {
      const obj = document.data()
      if (!inDateRange(obj.date, date1, date2)) return
      if (!matchesDailyProject(obj, projectFilter)) return
      const showers = toNum(obj.showers)
      total += showers
      details.push({
        id: document.id,
        date: obj.date || '',
        name: obj.name || '',
        showers,
      })
    })

    details.sort((a, b) => (a.date < b.date ? 1 : -1))
    setRows(details)
    setRows1([{ id: 'total', showers: total }])
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{ marginTop: '50px' }}>
        <div style={{ width: '100%' }}>
          <ProjectFilter value={projectFilter} onChange={handleProjects} />
          <TextField type="date" InputLabelProps={{ shrink: true }} className="addform" label="Start Date" variant="outlined" style={{ width: '45%' }} onChange={(e) => setdate1(e.target.value)} value={date1} />
          <TextField type="date" InputLabelProps={{ shrink: true }} className="addform" label="End Date" variant="outlined" style={{ width: '45%' }} onChange={(e) => setdate2(e.target.value)} value={date2} />
          <Button onClick={getData} disabled={projectFilter.length === 0} className="addform" variant="contained" style={{ marginBottom: '10px', width: '100%', height: '50px', marginTop: '30px', backgroundColor: '#F21D2F' }}>Search</Button>

          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>Overall Summary</Typography>
          <div style={{ height: '15vh', marginBottom: '20px' }}>
            <DataGrid rows={rows1} columns={summaryColumns} pageSize={1} rowsPerPageOptions={[1]} components={{ Toolbar: CustomToolbar }} />
          </div>

          <Typography variant="h6" sx={{ mb: 1 }}>Breakdown</Typography>
          <div style={{ height: 440 }}>
            <DataGrid rows={rows} columns={columns} pageSize={10} rowsPerPageOptions={[5]} components={{ Toolbar: CustomToolbar }} />
          </div>
        </div>
      </Box>
    </Box>
  )
}
